import { render } from "./ProductSelectionTrademarksSelectionItem.vue?vue&type=template&id=363a57c2&scoped=true&ts=true"
import script from "./ProductSelectionTrademarksSelectionItem.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionTrademarksSelectionItem.vue?vue&type=script&lang=ts"

import "./ProductSelectionTrademarksSelectionItem.vue?vue&type=style&index=0&id=363a57c2&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363a57c2"]])

export default __exports__